import {
  containerFluid,
  dangerColor,
  defaultBoxShadow,
  defaultFont,
  grayColor,
  infoColor,
  primaryColor,
  successColor,
  warningColor,
  whiteColor,
} from 'assets/jss/material-dashboard-pro-react.js';

const headerStyle = theme => ({
  appBar: {
    border: '0',
    display: 'block',
    boxShadow: 'none',
    borderBottom: '0',
    color: grayColor[6],
    borderRadius: '3px',
    backgroundColor: 'transparent',
    transition: 'all 150ms ease 0s',
  },
  container: {
    ...containerFluid,
    minHeight: '50px',
  },
  title: {
    ...defaultFont,
    lineHeight: '30px',
    fontSize: '18px',
    borderRadius: '3px',
    textTransform: 'none',
    color: 'inherit',
    paddingTop: '0.625rem',
    paddingBottom: '0.625rem',
    margin: '0 !important',
    letterSpacing: 'unset',
    '&:hover,&:focus': {
      background: 'transparent',
    },
  },
  primary: {
    backgroundColor: primaryColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  info: {
    backgroundColor: infoColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  success: {
    backgroundColor: successColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  warning: {
    backgroundColor: warningColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  danger: {
    backgroundColor: dangerColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  sidebarMinimize: {
    float: 'left',
    padding: '0 0 0 15px',
    display: 'block',
    color: grayColor[6],
  },
  '@keyframes fadeInUp': {
    from: {
      opacity: 0,
      transform: 'translate3d(0, 100%, 0)',
      '-webkit-transform': 'translate3d(0, 100%, 0)',
    },

    to: {
      opacity: 1,
      transform: 'none',
      '-webkit-transform': 'none',
    },
  },
  fastTrackTextColor: {
    color: '#000',
  },
  fastTrackTextStyles: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  fastTrackImageStyles: {
    width: 30,
    height: 30,
  },
});

export default headerStyle;
